import React from "react";
import "./styles.css";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import UserSelectAdd, { UserOption } from "../UserSelectAdd";
import { AG_GRID_LOCALE_CZ } from '@ag-grid-community/locale';
import DialogWindow from "../DialogWindow";

import useItemListCardLogic from "./useItemListLogicOP";
import { FetchItemsFn, Item, UiColumn } from "./types";

const myTheme = themeQuartz.withParams({
  fontSize: 17,
  headerFontSize: 17,
  rowHeight: 55,
  headerHeight: 48,
});

export interface ItemListCardProps {
  columns: UiColumn<Item>[];
  actions?: FloatingAction[];
  fetchItems: FetchItemsFn<Item>;
  onChangedScope: (scope: string) => void;
  scope: string;
  onPrintQRCodes?: (Items: Item[]) => void;
  onPrintStockItems?: () => void;
  rowSelectionMode?: boolean;
}

const ItemListOP: React.FC<ItemListCardProps> = ({ columns, fetchItems, onChangedScope, scope, onPrintQRCodes, onPrintStockItems, rowSelectionMode }) => {

  const logic = useItemListCardLogic({ columns, fetchItems, onChangedScope, scope, onPrintQRCodes, onPrintStockItems, rowSelectionMode });

  return <>
    {logic.showDialogArchiveItem && (
      <div className="inv-modal-overlay" onMouseDown={() => logic.setShowDialogArchiveItem(false)}>
        <div
          className="inv-modal"
          onMouseDown={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
        >
          <div className="inv-modal-title">Opravdu si přejete archivovat vybrané položky?</div>

          <div className="inv-modal-actions1">
            <button
              type="button"
              className="inv-btn"
              onClick={async () => {
                logic.setShowDialogArchiveItem(false);
                await logic.archiveSelectedStockItems();
              }}
            >
              Ano
            </button>
            <button
              type="button"
              className="inv-btn"
              onClick={() => logic.setShowDialogArchiveItem(false)}
            >
              Ne
            </button>
          </div>
        </div>
      </div>
    )}

    <div className="item-list-card">
      <div className="item-list-toolbar">
        <button
          type="button"
          className={`item-list-tab ${scope === "all" ? "is-active" : ""}`}
          onClick={() => { onChangedScope("all"); }}
        >
          Skladové zásoby
        </button>
        <button
          type="button"
          className={`item-list-tab ${scope === "allItems" ? "is-active" : ""}`}
          onClick={() => { onChangedScope("allItems"); }}
        >
          Skladové položky
        </button>
        <button
          type="button"
          className={`item-list-tab ${scope === "users" ? "is-active" : ""}`}
          onClick={() => { onChangedScope("users"); }}
        >
          Vydané na zaměstnance
        </button>

        <div className="item-list-toolbar-right">

          <button
            type="button"
            className={`item-list-tab is-active`}
            onClick={() => { onPrintStockItems && onPrintStockItems(); }}
          >
            Excel
          </button>

          <button
            type="button"
            className={`item-list-tab is-active`}
            onClick={() => { logic.printBarcodes() }}
          >
            Tisk čárových kódů
          </button>

          {logic.loggedUser?.userrole === "admin" && scope === "allItems" && <button
            type="button"
            className={`item-list-tab is-active`}
            onClick={() => { logic.onClickArchiveSelectedStockItems() }}
          >
            Archivovat položku
          </button>}

          <select
            value={logic.selectedStockState}
            onChange={logic.onChangeSelectedStock}
          >
            {logic.stocksState.map((o) => (
              <option key={o.id} value={o.id}>
                {o.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {
        scope === "users" &&
        <div className="user-selected-add-wrapper">
          <UserSelectAdd
            users={logic.selectedUsersState as any}
            valueId={logic.selectedUserState}
            onChange={logic.setSelectedUserId}
          />
        </div>
      }

      {logic.showDialog &&
        <DialogWindow
          displayDialog={logic.showDialog}
          setDisplayDialog={logic.setShowDialog}
          title={logic.dialogText}
          cancelText={"OK"}
        />
      }

      <div className="item-list-grid-wrapper">
        <AgGridReact
          theme={myTheme}
          columnDefs={logic.columnDefs}
          rowModelType="infinite"
          cacheBlockSize={100}
          datasource={logic.datasource}
          localeText={AG_GRID_LOCALE_CZ}
          suppressRowClickSelection={true}
          getRowId={(params) => params.data.id}
          rowSelection={rowSelectionMode ? logic.rowSelection : undefined}
          onGridReady={(e) => { logic.gridApiRef.current = e.api; }}
          onCellValueChanged={scope === "allItems" && logic.loggedUser?.userrole === "admin" ? logic.handleCellValueChanged : null}
        />
      </div>

      <div className="stockGrid__footer">
        {logic.countsByState?.length > 0 && (
          <span className="stockGrid__footerSep">
            Stav:
            <span className="stockGrid__chips">
              {logic.countsByState.map((x) => (
                <span key={x.key} className="stockGrid__chip">
                  {x.key}: <b>{x.count}</b>
                </span>
              ))}
            </span>
            <span className="stockGrid__footerDivider">|</span>
          </span>
        )}

        <span className="stockGrid__total">
          Celkem: <b>{logic.totalCount}</b>
        </span>
      </div>

      {
        logic.actions?.length ? (
          <div className="item-list-actions">
            <FloatingActions actions={logic.actions} />
          </div>
        ) : null
      }
    </div >
  </>;
};

export default ItemListOP;